import { CellRef } from "../../components/interfaces/Rule";

export const formatTableTotalsCellAddress = (cell: CellRef): string => `(${cell.row + 1}, ${cell.column + 1})`;

export const formatTableTotalsCellLabel = (cell: CellRef, value?: string): string => {
  const address = formatTableTotalsCellAddress(cell);
  return value ? `${address} ${value}` : address;
};
